import { useTranslation } from 'react-i18next'

import clsx from 'clsx'

import { AppIcon } from 'shared/ui/app-icon'
import { AllIcons } from 'shared/ui/app-icon/types'

import s from './styles.module.scss'

interface BestOffersHeaderProps {
  onViewAll?: () => void
}

export const BestOffersHeader = ({ onViewAll }: BestOffersHeaderProps) => {
  const { t } = useTranslation()

  return (
    <div className={clsx('container', s.header)}>
      <h2 className={clsx(s.title, 'bold-14')}>
        {t('kyrgyzstan_block.offers.title')}
      </h2>
      <button
        className={s.viewAll}
        onClick={onViewAll}
      >
        <span className="medium-14">
          {t('kyrgyzstan_block.offers.view_all')}
        </span>
        <AppIcon
          id={AllIcons.CHEVRON_RIGHT}
          width={12}
          height={12}
          className={s.arrowRight}
        />
      </button>
    </div>
  )
}
